import axios from "axios";

export const client = axios.create({
    baseURL: process.env.REACT_APP_API_SERVER_URL + "/"
});

let helpers = {};

// Add it to your helpers object
export function loadToken({ getAccessTokenSilently, loginWithRedirect }) {
    helpers.getAccessTokenSilently = getAccessTokenSilently;
    helpers.loginWithRedirect = loginWithRedirect;
}

async function getToken() {
    let options = {
        authorizationParams: {
            audience: process.env.REACT_APP_AUTH0_AUDIENCE
        },
    };

    try {
        const token = await helpers.getAccessTokenSilently(options);
        return token;
    } catch (e) {
        console.warn("Silent token retrieval failed. Redirecting to login...", e);

        // If silent auth fails (usually 'login_required' or 'consent_required'), 
        // trigger the redirect to the Auth0 Universal Login page.
        // if (helpers.loginWithRedirect) {
        //     helpers.loginWithRedirect({
        //         // Optional: Pass the current URL so the user returns to where they were
        //         appState: { returnTo: window.location.pathname }
        //     });
        // }

        throw e; // Still throw so the current Axios request is cleanly aborted
    }
}

// Your interceptor stays exactly the same!
client.interceptors.request.use(async function (config) {
    if (helpers.getAccessTokenSilently) {
        try {
            const token = await getToken();
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
        } catch (error) {
            return Promise.reject(error);
        }
    }
    return config;
});